/**
 * Top Page
 * @class Top
 */

import { gsap } from 'gsap';
import CurveSlider from '../modules/curve-slider.js';
import {imagePath} from '../helpers/helpers.js';

export default class Top {

  constructor() {
    const page = document.querySelector('.top');
    if (!page) return;
    this.init();
    this.isLoaded = false;
  }

  init() {
    this.loading();
  }

  loading(){
    gsap.set(".header", { autoAlpha: 0 ,yPercent: -50 });
    window.onload = ()=>{
      //this.element.classList.add('loaded');
      this.isLoaded = true;

      const loadingWrap = document.querySelector('.loading-wrap');

      const loadTl = gsap.timeline();
      loadTl.add(() => {
        document.querySelector('body').classList.add('loaded');
      }).to(loadingWrap, {
        delay: 0.5,
        autoAlpha: 0,
        duration: 0.5,
        ease: "power1.inOut",
      })
      .add(() => {
        loadingWrap.remove();
        this.heroAnimation();
      });
      new CurveSlider();

    }
  }


  /**
   * メインビジュアル
   * ランダムにキャラクター画像を表示
   * @private
   */
  heroAnimation() {
    let intervalId;
    const mediaQueryList = window.matchMedia('(min-width: 1000px)');
    let mainVisual = document.querySelector('.hero__inner');
    let charas = document.querySelector('.hero__charas');
    let logo = document.querySelector('.hero__contents');

    // gsap.set(".hero", { autoAlpha: 0 });
    // gsap.set(".charas", { y: 130 });
    gsap.set(".header__logo", { scale: 0.9 });

    // heroTl.
    // to(".hero", { autoAlpha: 1, duration: 2,delay: 1.4 })
    // .to(".charas", { y: 0, duration: 1,delay: 1.4 });

    // gsap.to(".hero", { autoAlpha: 1, duration: 2,delay: 1.4 });
    // gsap.to(".charas", { y: 0, duration: 1,delay: 1.4 });
    gsap.to(".header__logo", { scale: 1, duration: 0.3,delay: 1.0 });
    gsap.to(".header", { autoAlpha: 1 ,yPercent: 0, duration: 0.5,delay: 0.2 });
    let isPc = true;

    const imageUrls1 = [
      { url: imagePath + '/assets/images/common/characters/chara01.png', className: 'chara1', posClassName: 'pos1', xaxis: "right", yaxis: "top", y: "4%", ballon: true, ballonUrl: imagePath + '/assets/images/common/characters/chara01_ballon.png',ballonAlt: '症状を見逃さない' },
      { url: imagePath + '/assets/images/common/characters/chara02.png', className: 'chara2', posClassName: 'pos2', xaxis: "right", yaxis: "bottom", y: "7.4%", ballon: true, ballonUrl: imagePath + '/assets/images/common/characters/chara02_ballon.png',ballonAlt: '早期発見につながる' },
      { url: imagePath + '/assets/images/common/characters/chara03.png', className: 'chara3', posClassName: 'pos3', xaxis: "left", yaxis: "top", y: "6%", ballon: true, ballonUrl: imagePath + '/assets/images/common/characters/chara03_ballon.png',ballonAlt: '突然の発作あわてない' },
      { url: imagePath + '/assets/images/common/characters/chara04.png', className: 'chara4', posClassName: 'pos4', xaxis: "left", yaxis: "bottom", y: "8%", ballon: true, ballonUrl: imagePath + '/assets/images/common/characters/chara04_ballon.png',ballonAlt: '複雑な情報をわかりやすく' },
      { url: imagePath + '/assets/images/common/characters/chara05.png', className: 'chara5', posClassName: 'pos5', xaxis: "left", yaxis: "top", y: "29%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara06.png', className: 'chara6', posClassName: 'pos6', xaxis: "left", yaxis: "top", y: "10%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara07.png', className: 'chara7', posClassName: 'pos7', xaxis: "left", yaxis: "bottom", y: "8%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara08.png', className: 'chara8', posClassName: 'pos8', xaxis: "right", yaxis: "top", y: "32%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara09.png', className: 'chara9', posClassName: 'pos9', xaxis: "right", yaxis: "top", y: "10%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara10.png', className: 'chara10', posClassName: 'pos10', xaxis: "right", yaxis: "bottom", y: "10.5%", ballon: false, ballonUrl: '' }
    ];

    const imageUrls2 = [
      { url: imagePath + '/assets/images/common/characters/chara11.png', className: 'chara11', posClassName: 'pos1', xaxis: "right", yaxis: "top", y: "4%", ballon: true, ballonUrl: imagePath + '/assets/images/common/characters/chara11_ballon.png',ballonAlt: '周りの人にも理解してほしい' },
      { url: imagePath + '/assets/images/common/characters/chara12.png', className: 'chara12', posClassName: 'pos2', xaxis: "right", yaxis: "bottom", y: "7.4%", ballon: true, ballonUrl: imagePath + '/assets/images/common/characters/chara12_ballon.png',ballonAlt: '症状についてわかりやすく' },
      { url: imagePath + '/assets/images/common/characters/chara03.png', className: 'chara3', posClassName: 'pos3', xaxis: "left", yaxis: "top", y: "6%", ballon: true, ballonUrl: imagePath + '/assets/images/common/characters/chara03_ballon.png',ballonAlt: '突然の発作あわてない' },
      { url: imagePath + '/assets/images/common/characters/chara13.png', className: 'chara13', posClassName: 'pos4', xaxis: "left", yaxis: "bottom", y: "8%", ballon: true, ballonUrl: imagePath + '/assets/images/common/characters/chara13_ballon.png',ballonAlt: '知りたい情報がある' },
      { url: imagePath + '/assets/images/common/characters/chara14.png', className: 'chara14', posClassName: 'pos5-2', xaxis: "left", yaxis: "top", y: "29%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara15.png', className: 'chara15', posClassName: 'pos6', xaxis: "left", yaxis: "top", y: "10%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara07.png', className: 'chara7', posClassName: 'pos7', xaxis: "left", yaxis: "bottom", y: "8%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara16.png', className: 'chara16', posClassName: 'pos8', xaxis: "right", yaxis: "top", y: "32%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara09.png', className: 'chara9', posClassName: 'pos9', xaxis: "right", yaxis: "top", y: "10%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara10.png', className: 'chara10', posClassName: 'pos10', xaxis: "right", yaxis: "bottom", y: "10.5%", ballon: false, ballonUrl: '' }
    ];

    const spImageUrls1 = [
      { url: imagePath + '/assets/images/common/characters/chara01.png', className: 'chara1', posClassName: 'pos1', xaxis: "right", yaxis: "bottom", y: "9.5%", ballon: true, ballonUrl: imagePath + '/assets/images/common/characters/chara01_ballon.png',ballonAlt: '症状を見逃さない' },
      { url: imagePath + '/assets/images/common/characters/chara02_sp.png', className: 'chara2', posClassName: 'pos2', xaxis: "left", yaxis: "top", y: "12%", ballon: true, ballonUrl: imagePath + '/assets/images/common/characters/chara02_ballon.png',ballonAlt: '早期発見につながる' },
      { url: imagePath + '/assets/images/common/characters/chara09_sp.png', className: 'chara9', posClassName: 'pos3', xaxis: "right", yaxis: "top", y: "8.0%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara06.png', className: 'chara6', posClassName: 'pos4', xaxis: "left", yaxis: "bottom", y: "7.2%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara10_sp.png', className: 'chara10', posClassName: 'pos5', xaxis: "right", yaxis: "top", y: "27.5%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara05.png', className: 'chara5', posClassName: 'pos6', xaxis: "left", yaxis: "top", y: "30%", ballon: false, ballonUrl: '' },
    ];

    const spImageUrls2 = [
      { url: imagePath + '/assets/images/common/characters/chara11.png', className: 'chara11', posClassName: 'pos1', xaxis: "right", yaxis: "bottom", y: "9.5%", ballon: true, ballonUrl: imagePath + '/assets/images/common/characters/chara11_ballon.png',ballonAlt: '周りの人にも理解してほしい' },
      { url: imagePath + '/assets/images/common/characters/chara03_sp.png', className: 'chara3', posClassName: 'pos2', xaxis: "left", yaxis: "top", y: "8%", ballon: true, ballonUrl: imagePath + '/assets/images/common/characters/chara03_ballon_sp.png',ballonAlt: '突然の発作慌てない' },
      { url: imagePath + '/assets/images/common/characters/chara09_sp.png', className: 'chara9', posClassName: 'pos3', xaxis: "right", yaxis: "top", y: "8.0%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara06.png', className: 'chara6', posClassName: 'pos4', xaxis: "left", yaxis: "bottom", y: "7.2%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara16.png', className: 'chara16', posClassName: 'pos5-2', xaxis: "right", yaxis: "top", y: "28.5%", ballon: false, ballonUrl: '' },
      { url: imagePath + '/assets/images/common/characters/chara14.png', className: 'chara14', posClassName: 'pos6-2', xaxis: "left", yaxis: "top", y: "29%", ballon: false, ballonUrl: '' },
    ];

    const pcImgeArrays = [imageUrls1, imageUrls2];
    const spImgeArrays = [spImageUrls1, spImageUrls2];


    let currentImages = imageUrls1;
    let currentIndex = 1;


    let usedImages = [];

    const positions = [
      { xaxis: "left", x: "70%", yaxis: "top", y: "5%", ballon: true },
      { xaxis: "left", x: "70%", yaxis: "top", y: "70%", ballon: true },
      { xaxis: "left", x: "30%", yaxis: "top", y: "5%", ballon: true },
      { xaxis: "left", x: "30%", yaxis: "top", y: "70%", ballon: true },
      { xaxis: "left", x: "75%", yaxis: "top", y: "40%", ballon: false },
      { xaxis: "left", x: "90%", yaxis: "top", y: "5%", ballon: false },
      { xaxis: "left", x: "90%", yaxis: "top", y: "70%", ballon: false },
      { xaxis: "left", x: "20%", yaxis: "top", y: "40%", ballon: false },
      { xaxis: "left", x: "10%", yaxis: "top", y: "5%", ballon: false },
      { xaxis: "left", x: "10%", yaxis: "top", y: "70%", ballon: false }
    ];

    let usedPositions = [];

    function getRandomUniqueImage(usedImages) {
      let availableImages = currentImages.filter((url, index) => !usedImages.includes(index));

      if (availableImages.length === 0) {
        availableImages = currentImages;
        usedImages = [];
      }

      const randomIndex = Math.floor(Math.random() * availableImages.length);
      const imageIndex = currentImages.indexOf(availableImages[randomIndex]);
      usedImages.push(imageIndex);
      return { imageUrl: availableImages[randomIndex], index: imageIndex };
    }



    /**
    * イベントリスナー
    */
    const listener = (event) => {
      // リサイズ時に行う処理
      if (event.matches) {
        isPc = true;
        usedImages = [];
        charas.innerHTML = '';
        currentImages = imageUrls1;
        clearInterval(intervalId);  // 定期処理停止
        initRandomImage();
        // console.log('PC用ブレークポイント用処理');
      } else {
        isPc = false;
        usedImages = [];
        charas.innerHTML = '';
        currentImages = spImageUrls1;
        clearInterval(intervalId);  // 定期処理停止
        initRandomImage();
        // console.log('SP用ブレークポイント用処理');
      }
    };

    // リスナー登録
    // mediaQueryList.addListener(listener); // @deprecated
    mediaQueryList.addEventListener("change", listener);

    // 初期化処理
    listener(mediaQueryList);


    function initRandomImage() {

      for (let i = 0; i < currentImages.length; i++) {
        let { imageUrl, index } = getRandomUniqueImage(usedImages);
        let wrap = document.createElement('div');
        let image = document.createElement('img');
        wrap.appendChild(image);

        const showBallon = imageUrl["ballon"];
        if (showBallon) {
          let ballon = document.createElement('img');
          ballon.src = imageUrl["ballonUrl"];
          ballon.className = "ballon";
          ballon.alt = imageUrl["ballonAlt"];
          wrap.appendChild(ballon);
        }

        image.src = imageUrl["url"];
        wrap.className = "pos " + imageUrl["className"] + " " + imageUrl["posClassName"];
        image.className = "chara-img";
        image.alt = "";
        charas.appendChild(wrap);

        let xdirection = imageUrl["xaxis"];
        let ydirection = imageUrl["yaxis"];
        if (xdirection === "left") {
          wrap.style.left = '50%';
        }
        else {
          wrap.style.right = '50%';
        }

        if (ydirection === "top") {
          wrap.style.top = imageUrl["y"];
        }
        else {
          wrap.style.bottom = imageUrl["y"];
        }
      }
      intervalId = window.setInterval(shuffle, 12000);
      document.addEventListener('visibilitychange', visibilityChangeHandler, false);

    }


    function shuffle() {
      let arraylength;
      let prevImages = currentImages;
      if (isPc) {
        arraylength = pcImgeArrays.length;
      }
      else {
        arraylength = spImgeArrays.length;
      }
      currentIndex += 1;
      if (currentIndex > arraylength) currentIndex = 1;

      if (isPc) {
        currentImages = pcImgeArrays[currentIndex - 1];
        arraylength = pcImgeArrays.length;
      }
      else {
        currentImages = spImgeArrays[currentIndex - 1];
        arraylength = spImgeArrays.length;
      }


      usedImages = [];
      // currentImages = currentImages === imageUrls1 ? imageUrls2 : imageUrls1;

      for (let i = 0; i < currentImages.length; i++) {
        let { imageUrl, index } = getRandomUniqueImage(usedImages);
        let wrap = document.createElement('div');
        let image = document.createElement('img');
        wrap.appendChild(image);

        const showBallon = imageUrl["ballon"];
        if (showBallon) {
          let ballon = document.createElement('img');
          ballon.src = imageUrl["ballonUrl"];
          ballon.className = "ballon";
          ballon.alt = imageUrl["ballonAlt"];
          wrap.appendChild(ballon);
        }

        image.src = imageUrl["url"];
        wrap.className = "pos " + imageUrl["className"] + " " + imageUrl["posClassName"];
        image.className = "chara-img";
        image.alt = "";
        charas.appendChild(wrap);

        let xdirection = imageUrl["xaxis"];
        let ydirection = imageUrl["yaxis"];
        if (xdirection === "left") {
          wrap.style.left = '50%';
        }
        else {
          wrap.style.right = '50%';
        }

        if (ydirection === "top") {
          wrap.style.top = imageUrl["y"];
        }
        else {
          wrap.style.bottom = imageUrl["y"];
        }

        let prevclassName = prevImages[index]["className"];
        // console.log(prevclassName, index);
        let prev = document.querySelector('.' + prevclassName);
        let tl = gsap.timeline();
        tl
          .to(prev, { autoAlpha: 0, duration: 0.4, delay: i * 0.05, })
          .fromTo(wrap, {
            autoAlpha: 0,
          }, {
            autoAlpha: 1,
            duration: 1.8,
            ease: "power4.inOut",
            delay: i * 0.05,
          }, "-=0.3"

          ).add(() => {
            prev.remove();
          }
          )
      }

    }

    function visibilityChangeHandler() {
      let date = new Date();
      // ページの表示・非表示状態を判断
      if (document.hidden) {
        clearInterval(intervalId);  // 定期処理停止
      } else {
        usedImages = [];
        charas.innerHTML = '';


        // 画面幅に応じて currentImages を設定
        if ( window.innerWidth >= 1000) {  // 768px 以下の場合 spimageUrls1 を使用
          currentImages = imageUrls1;
        } else {
          currentImages = spImageUrls1;
        }


        initRandomImage();
      }
    }




  }

}
